import styled from "@emotion/styled";
import { baseWidths, colors, footer, header } from "src/theme";
import { mediaQuery } from "src/common";

const ContentStyle = styled.div({
  position: 'relative',
  paddingTop: `${header.mobileHeight}px`,
  backgroundColor: colors.background6,
  minHeight: `calc(100vh - ${footer.mobileHeight}px)`,

  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height}px)`,
  },

  [mediaQuery('laptopL')]: {
    paddingTop: `${header.height}px`,
  },
})

const ContainerStyle = styled.div({
  width: '88%',
  //paddingBlock: '60px', -ako ima HeaderWidget
  paddingBlock: '32px',
  margin: '0 auto',

  [mediaQuery('laptopL')]: {
   // paddingBlock: '70px' -ako ima HeaderWidget
    paddingBlock: '32px',
  },
})

export const ContainerComponent = styled.div({
  margin: '0 auto',

  [mediaQuery('mobile')]: {
    width: `${baseWidths.mobile}px`
  },
})

interface ContentProps {
  children: React.JSX.Element | React.JSX.Element[];
}

export const Content = ({ children }: ContentProps) =>
  <ContentStyle>
    <ContainerStyle>
      {children}
    </ContainerStyle>
  </ContentStyle>;
